import { RouterState, EnterHook } from 'react-router';

import { Language } from 'ha/i18n';

const redirectedRoutes = [
  {
    path: 'faq',
    getNextPath: () => '/answers',
  },
  {
    path: 'eaie',
    getNextPath: () => '/university-plans',
  },
  {
    path: 'join',
    getNextPath: () =>
      '/university-plans?utm_source=nafsa&utm_medium=promotional_link&utm_campaign=nafsa+2017&utm_content=animation',
  },
  {
    path: 'unsubscribe',
    getNextPath: () => '/my/subscriptions',
  },
  {
    path: 'search/*',
    getNextPath: (nextState: RouterState) =>
      `${nextState.params.lang ? `/${nextState.params.lang}` : ''}/s/${
        nextState.params.splat
      }`,
  },
  {
    path: 'hello/*',
    getNextPath: (nextState: RouterState) => `/h/${nextState.params.splat}`,
  },
  {
    path: '/admin/conversation',
    getNextPath: (nextState: RouterState) =>
      `/admin/conversations/${nextState.location.query.cid}`,
  },
  {
    path: 'city/*',
    getNextPath: (nextState: RouterState) =>
      `${nextState.params.lang ? `/${nextState.params.lang}` : ''}/${
        nextState.params.splat
      }`,
  },
  {
    path: '/my/payment-form',
    getNextPath: (nextState: RouterState) =>
      `/my/talk/${nextState.location.query.id}/book`,
  },
  {
    path: 'how-to-list',
    getNextPath: () => '/become-an-advertiser',
  },
  {
    path: 'about',
    getNextPath: () => '/',
  },
  // We don't have PT and ZH in contenfull, but CTA on Home page in these languages leads to 404
  // We might remove that page in the future at all, so far we set redirects to EN
  {
    path: '/pt/become-an-advertiser',
    getNextPath: () => '/become-an-advertiser',
  },
  {
    path: '/zh/become-an-advertiser',
    getNextPath: () => '/become-an-advertiser',
  },
  // temporarily redirect old payment-methods route to the new one
  {
    path: '/my/payment-methods',
    getNextPath: () => '/my/payments/methods',
  },
  {
    path: '/my/payment-requests',
    getNextPath: () => '/my/payouts/payment-requests',
  },
  {
    path: '/how-to-book',
    getNextPath: () => '/renting',
  },
  {
    path: '/pricing',
    getNextPath: () => '/pricing/tenants',
  },
  {
    path: '/nl/Nederland/verhuren-van-vastgoed',
    getNextPath: () => '/nl/Nederland/woning-verhuren',
  },
  {
    path: '/de/vermietung',
    getNextPath: () => '/de/Deutschland/vermietung',
  },
  {
    path: '/rentradar',
    getNextPath: () => 'https://rentradar.housinganywhere.com/',
  },
  {
    path: 'agb',
    getNextPath: () => '/terms',
  },
];

const commissionRedirects = Object.keys(Language).map(lang => {
  return {
    path: `${lang === Language.en ? '' : lang}/faq-commission`,
    getNextPath: () =>
      `${lang === Language.en ? '' : `/${lang}`}/pricing/landlords`,
  };
});

redirectedRoutes.push(...commissionRedirects);

export const onEnterUserProfile: EnterHook = (
  { location, params },
  replace,
  callback,
) => {
  replace({
    pathname: `/users/show/${params.userID}`,
    search: location.search,
    query: location.query,
    state: location.state,
  });

  if (callback) {
    callback();
  }
};

export const onEnterRoomPage: EnterHook = (
  { location, params },
  replace,
  callback,
) => {
  replace({
    pathname: `/room/${params.splat}`,
    search: location.search,
    query: location.query,
    state: location.state,
  });

  if (callback) {
    callback();
  }
};

export default redirectedRoutes.map(({ path, getNextPath }) => {
  let onEnter: EnterHook;

  onEnter = (nextState, replace, callback) => {
    const { search, query, state } = nextState.location;

    replace({
      pathname: getNextPath(nextState),
      search,
      query,
      state,
    });

    if (callback) {
      callback();
    }
  };

  return { path, onEnter };
});
